import FilterDrawer from 'components/Rubrics/FilterDrawer';
import { useDialog } from 'contexts/dialog';
import { useViewport } from 'contexts/viewport';
import { PageContext } from 'pages/Rubrics/PageProvider';
import Desktop from 'pages/Rubrics/desktop';
import Mobile from 'pages/Rubrics/mobile';
import Tablet from 'pages/Rubrics/tablet';
import { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import rubricService from 'services/rubric';
import { Loading } from 'shell/components';
import { exportRubricToCSV } from 'utils/helper';

const PageLayout = () => {
    const { setDialog, closeDialog } = useDialog();
    const history = useHistory();
    const { device } = useViewport();

    const {
        filters,
        setFilters,
        resetFilters,
        rubrics,
        setRubrics,
        sortedFilteredRubrics,
        sortState,
        handleSetSortState,
    } = useContext(PageContext);

    const getFilterCount = (filters, sortState) => {
        let count = 0;
        if (sortState.orderBy) count++;
        // if (filters.sort !== 'namea-z') count++;
        return count;
    };

    const onClickEdit = ({ id }) => {
        history.push(`/rubrics/${id}/edit`);
    };

    const onClickDownloadCSV = (rubric) => {
        exportRubricToCSV(rubric.rubric);
    };

    const onClickDelete = (rubricToDelete) => {
        setDialog({
            open: true,
            message: 'Delete Rubric?',
            description: 'Deleting this rubric is permanent and cannot be undone.',
            note: '',
            variant: 'destructive',
            actionButtonText: 'Delete',
            cancelButtonText: 'Cancel',
            onAction: async () => {
                history.push(`/rubrics`);
                setRubrics((current) => {
                    return current.filter(({ id }) => id !== rubricToDelete.id);
                });
                rubricService.deleteRubric(rubricToDelete.id);
                closeDialog();
            },
            onCancel: () => closeDialog(),
            onClose: () => closeDialog(),
        });
    };

    const props = {
        rubrics: sortedFilteredRubrics,
        filters,
        setFilters,
        getFilterCount,
        onClickEdit,
        onClickDownloadCSV,
        onClickDelete,
        sortState,
        handleSetSortState,
    };

    const renderResponsiveLayout = (device) => {
        return {
            mobile: <Mobile {...props} />,
            tablet: <Tablet {...props} />,
            desktop: <Desktop {...props} />,
        }[device];
    };

    return !rubrics ? (
        <Loading />
    ) : (
        <>
            {renderResponsiveLayout(device)}
            <FilterDrawer
                filters={filters}
                setFilters={setFilters}
                resetFilters={resetFilters}
                sortState={sortState}
                handleSetSortState={handleSetSortState}
            />
        </>
    );
};

export default PageLayout;
